module.exports = __webpack_public_path__ + "static/media/members.1b184134.jpg";